<template>
  <RadioList v-model="unit" :items="unitTypes" :disabledKeys="disabledKeys" class="unit" />
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import RadioList from '@/components/atoms/RadioList'
import aggregateMixin from './mixin'

export default {
  name: 'AnalysisUnit',
  components: {
    RadioList,
  },
  mixins: [aggregateMixin],
  props: {
    disabled: {
      type: Boolean,
      required: true,
    },
    refetch: {
      type: Function,
      required: true,
    },
    useRanking: {
      type: Boolean,
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      conditions: state => state.analysis.aggregate.conditions,
      byId: state => state.analysis.unit.byId,
      allIds: state => state.analysis.unit.allIds,
    }),
    ...mapGetters({
      isBetween: 'analysis/aggregate/isBetween',
    }),
    unit: {
      get() {
        return this.conditions.unit
      },
      set(unit) {
        this.$store.commit('analysis/aggregate/update', { unit })
        this.search()
      },
    },
    unitTypes() {
      const unitTypes = { ...this.byId }
      if (!this.useRanking) {
        delete unitTypes[5]
      }
      return unitTypes
    },
    disabledKeys() {
      return this.disabled ? this.allIds.filter(id => id !== this.unit) : []
    },
  },
}
</script>

<style lang="postcss" scoped>
.unit {
  grid-auto-columns: auto;
  width: 100%;
}

>>> input[type='radio']:disabled + span {
  background-color: var(--white) !important;
  color: var(--text-color) !important;
}
</style>
